import Card from '@common/components/card';
import { ENotesVisibility, NotesModel } from '@modules/core/types';
import React from 'react';
import moment from 'moment';
import { SimpleUser } from '@common/types/objects';
import ProfileImage from '@common/components/profile-image';
import Icon from '@common/components/icon';
import { useTranslation } from 'react-i18next';
import Attachment from '@common/components/attachment';
import { Row } from '@common/components/form';
import { useHistory } from 'react-router';
import { Button } from '@common/components/button';


type NoteProps = {
  note: NotesModel;
  showVisibility?: boolean;
  onDelete?: () => void;
};

export const Note = React.memo(({ note, showVisibility = false, onDelete }: NoteProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const noteCreator = note.created_by as SimpleUser;
  const isShowDeleteButton = showVisibility && !note.deleted_by && !note.deleted_at;

  const visibilityText: Record<ENotesVisibility, string> = {
    [ENotesVisibility.ALL_ADMINS]: t('core:add_note_visibility_admins_text'),
    [ENotesVisibility.EMPLOYEE]: t('core:add_note_visibility_employee_text'),
    [ENotesVisibility.CREATOR]: t('core:add_note_visibility_creator_text')
  };

  const goToUser = () => {
    history.push(`/admin/users/${noteCreator.id}`);
  };

  return (
    <div className="Note__Container">
      <div className="Note__ContainerLine" />

      <div className="Note__Creator">
        <div className="tw-flex tw-flex-row tw-gap-2 tw-items-center tw-justify-between">
          <div className="Note__CreatorName" onClick={goToUser}>
            <ProfileImage
              user={noteCreator}
              size={20}
            />
            <span>{noteCreator.full_name}</span>

          </div>
          {isShowDeleteButton && (
            <div className="tw-flex tw-flex-row tw-gap-2 tw-items-center">
              <Button
                icon="delete"
                iconColor="red"
                className="Table__DropdownTrigger"
                onClick={onDelete}
              />
            </div>
          )}
        </div>
        <span className="Note__CreatorDate tw-ml-[2px]">{moment(note.created_at).format('MMM D, YYYY HH:mm')}</span>
      </div>

      <div className="Note__Content tw-ml-[2px] !tw-bg-form-submission-note">
        <Card containerClassName="Note__Body">
          <Card.Content>
            <p className={`${note.deleted_by && note.deleted_at ? 'tw-text-gray-custom-500 tw-font-medium tw-italic' : ''}`}>
              {note.deleted_by && note.deleted_at
            ? t('core:note_soft_deleted_text', {
              deletedBy: (note.deleted_by as SimpleUser).full_name,
              deletedAt: moment(note.deleted_at).format('DD-MM-YY [at] HH:mm')
}) : note.text}
            </p>
            <Row className="tw-flex tw-flex-row tw-gap-2">
              {note.attachments.length > 0 && note.attachments.map((attachment) => (
                <Attachment
                  key={attachment.id}
                  item={attachment}
                  maxHeight={100}
                  isOnlyForView
                  className="tw-rounded-md tw-overflow-hidden"
                />
              ))}
            </Row>
            {showVisibility && (
              <span className="Note__Visibility">
                <Icon type="visibility" size={16} />
                {visibilityText[note.visibility]}
              </span>
            )}
          </Card.Content>
        </Card>
      </div>
    </div>
  );
});
